import {
  Dialog,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { memo, useState, useEffect } from "react";
import { CloseIcon, PinImage, Uplodeimg } from "../Assets/Icon";
import { Close } from "@mui/icons-material";
import { Box } from "@mui/system";
import { ToastContainer, toast } from "react-toastify";
import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";

function FileAttachment({
  setAttachmentLink,
  AttachmentLink,
  setRefresh,
  refresh,
  editAttach,
  setEditAttach,
}) {
  const [pin, setpin] = useState(false);
  const handleOpenpin = () => setpin(true);
  const handleClosepin = () => setpin(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [file, setFile] = useState([]);

  const allowedExtensions = [
    "png",
    "jpg",
    "jpeg",
    "pdf",
    "xls",
    "xlsx",
    "doc",
    "docx",
  ];

  const handleFileChange = async (e) => {
    const chosenFiles = Array.from(e.target.files);
    const Files = [...file];

    for (const selectedFile of chosenFiles) {
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      const fileSizeInMB = selectedFile.size / (1024 * 1024); // convert bytes to MB

      if (!allowedExtensions.includes(fileExtension)) {
        toast.error(`File type not allowed: ${selectedFile.name}`);
        continue;
      }

      if (fileSizeInMB > 5) {
        toast.error(`${selectedFile.name} exceeds 5MB limit`);
        continue;
      }

      if (Files.length >= 3) {
        toast.error(`You can upload a maximum of 3 files`);
        break;
      }

      if (Files.findIndex((f) => f.name === selectedFile.name) === -1) {
        Files.push(selectedFile);
        setFile([...Files]);

        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
          const response = await global.$axios.post("ticket/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          });

          if (response.data.Status === 200) {
            setAttachmentLink((prev) => [...prev, response.data.Message]);
            toast.success(`${selectedFile.name} uploaded successfully`);
          } else {
            toast.error(`Failed to upload ${selectedFile.name}`);
          }
        } catch (err) {
          console.error("Upload error:", err);
          toast.error(`Upload failed for ${selectedFile.name}`);
        }
      }
    }
  };

  const removeFileAndAttachmentAtIndex = (index) => {
    const updatedFiles = [...file];
    const updatedAttachments = [...AttachmentLink];

    if (index < updatedFiles.length) {
      updatedFiles.splice(index, 1);
      setFile(updatedFiles);
    }

    if (index < updatedAttachments.length) {
      updatedAttachments.splice(index, 1);
      setAttachmentLink(updatedAttachments);
    }

    setRefresh(!refresh);
  };

  useEffect(() => {
    if (editAttach) {
      let updateFile = [];
      AttachmentLink?.map((item) => {
        const FindIndex = item.indexOf("-");
        const name = item.slice(FindIndex + 1);
        updateFile.push({ name: name });
      });
      setFile(updateFile);
      setEditAttach(false);
    }
  }, [editAttach]);

  return (
    <>
      <div
        style={{ display: "flex", cursor: "pointer" }}
        onClick={handleOpenpin}
      >
        <PinImage style={{ width: "18px", height: "18px" }} />
        <span style={{ fontSize: "12px" }}>Insert a File...</span>
      </div>
      <Grid item container xs={12}>
        {file.map((item, index) => {
          const fileName = item.name?.toLowerCase() || "";
          const isImage = /\.(png|jpe?g)$/i.test(fileName);
          const isPDF = /\.pdf$/i.test(fileName);
          let FileIcon;
          if (isImage) {
            FileIcon = ImageIcon;
          } else if (isPDF) {
            FileIcon = PictureAsPdfIcon;
          } else {
            FileIcon = DescriptionIcon;
          }

          return (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                margin: "5px 0",
              }}
            >
              <FileIcon
                style={{
                  width: "20px",
                  height: "20px",
                  color: "rgb(45, 113, 188)",
                }}
              />
              <span
                style={{
                  fontSize: "12px",
                  maxWidth: "120px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.name}
              </span>
              <IconButton onClick={() => removeFileAndAttachmentAtIndex(index)}>
                <Close />
              </IconButton>
            </div>
          );
        })}
      </Grid>
      <>
        <Dialog
          maxWidth="sm"
          fullWidth
          fullScreen={fullScreen}
          open={pin}
          onClose={handleClosepin}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ padding: "20px" }}>
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 0",
                borderBottom: "1px solid rgba(0,0,0,0.04)",
              }}
            >
              <span style={{ color: "#0071BC", fontWeight: 500 }}>
                Attachment File
              </span>
              <IconButton
                onClick={() => {
                  handleClosepin();
                }}
                sx={{ padding: "0px" }}
              >
                <CloseIcon style={{ width: "25px", height: "25px" }} />
              </IconButton>
            </div>

            {/* Image or icon placeholder */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <Uplodeimg />
            </div>

            {/* File Upload Input */}
            <Grid
              container
              justifyContent="center"
              style={{ marginTop: "20px" }}
            >
              <input
                type="file"
                accept=".png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx"
                id="file"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label
                htmlFor="file"
                style={{
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                  background: "rgb(45,113,188)",
                  color: "#fff",
                  padding: "5px 12px",
                  borderRadius: "10px",
                }}
              >
                Select File
              </label>
            </Grid>

            {/* File Preview */}
            <Grid
              container
              justifyContent="center"
              spacing={2}
              flexDirection={"column"}
              alignItems={"center"}
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              {AttachmentLink.map((fileInfo, index) => {
                const fileName = fileInfo?.name || fileInfo?.split("/").pop();
                const fileURL = fileInfo;
                const isImage = /\.(png|jpe?g)$/i.test(fileName);
                const isPDF = /\.pdf$/i.test(fileName);
                const isDocOrExcelOrCSV = /\.(docx?|xlsx?|csv)$/i.test(
                  fileName
                );

                return (
                  <Grid key={index} item>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "10px",
                        width: "200px",
                      }}
                    >
                      {isImage ? (
                        <img
                          src={fileURL}
                          alt="Preview"
                          style={{
                            width: "200px",
                            height: "200px",
                            objectFit: "contain",
                            borderRadius: 4,
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(fileURL, "_blank")}
                        />
                      ) : isPDF ? (
                        <div
                          style={{
                            width: "200px",
                            height: "200px",
                            border: "1px solid #ccc",
                            borderRadius: 4,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            padding: "10px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{ wordBreak: "break-word" }}
                          >
                            {fileName || "PDF File"}
                          </Typography>
                          <button
                            onClick={() => window.open(fileURL, "_blank")}
                            style={{
                              marginTop: "10px",
                              cursor: "pointer",
                              padding: "4px 8px",
                              background: "#1976d2",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              fontSize: "12px",
                            }}
                          >
                            View
                          </button>
                        </div>
                      ) : isDocOrExcelOrCSV ? (
                        <iframe
                          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                            fileURL
                          )}&action=embedview&wdAllowInteractivity=True&wdbipreview=True`}
                          width="200px"
                          height="200px"
                          frameBorder="0"
                          title="Office File Preview"
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "200px",
                            height: "200px",
                            border: "1px solid #ccc",
                            borderRadius: 4,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            padding: "10px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{ wordBreak: "break-word" }}
                          >
                            {fileName || "File"}
                          </Typography>
                          <button
                            onClick={() => window.open(fileURL, "_blank")}
                            style={{
                              marginTop: "10px",
                              cursor: "pointer",
                              padding: "4px 8px",
                              background: "#1976d2",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              fontSize: "12px",
                            }}
                          >
                            View
                          </button>
                        </div>
                      )}

                      <button
                        onClick={() => removeFileAndAttachmentAtIndex(index)}
                        style={{
                          cursor: "pointer",
                          padding: "4px 8px",
                          background: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          fontSize: "12px",
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  </Grid>
                );
              })}
            </Grid>

            {/* Upload Instructions and Button */}
            <Grid
              container
              direction="column"
              spacing={1}
              style={{
                margin: "20px 0 10px 0",
                fontSize: "13px",
                alignItems: "center",
              }}
            >
              <Grid item>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{
                    marginTop: 4,
                    fontSize: "13px",
                    textAlign: "center",
                  }}
                >
                  * Accepted file types:{" "}
                  <strong>
                    .png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx
                  </strong>
                  <br />* Maximum <strong>3 files</strong> can be uploaded, each
                  up to <strong>5MB</strong>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      </>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        fontSize={"14px"}
        fontWeight={"600"}
        color={"#232323"}
      />
    </>
  );
}

export default memo(FileAttachment);
